// extracted by mini-css-extract-plugin
export default {"divisionFormWidget":"DivisionFormWidget_divisionFormWidget__SuQOc","buttonts":"DivisionFormWidget_buttonts__HM9Hl"};